export default "__VITE_ASSET__d5d4c37f__"